import { render, staticRenderFns } from "./ChoiceSelector.vue?vue&type=template&id=445e7696&scoped=true&"
import script from "./ChoiceSelector.vue?vue&type=script&lang=js&"
export * from "./ChoiceSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445e7696",
  null
  
)

export default component.exports